// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import SiteLayout from 'layouts/SiteLayout'
import HomeLayout from 'layouts/HomeLayout'
import MainLayout from 'layouts/MainLayout'
import CategoryLayout from 'layouts/CategoryLayout'
import Page from 'views/page/Page'

// Redux:
import { setOnLineStatus, setConnectionStatus } from 'actions/site'

class SiteContainer extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		this.nativeConnection = !! window.navigator.connection

		if ( this.nativeConnection ) {
			this.updateConnectionStatus()

			navigator.connection.addEventListener( 'onchange', this.updateConnectionStatus )
		}

		this.updateOnLineStatus()
		window.addEventListener( 'online', this.updateOnLineStatus )
		window.addEventListener( 'offline', this.updateOnLineStatus )
	}

	componentWillUnmount() {
		if ( this.nativeConnection ) {
			navigator.connection.removeEventListener( 'onchange', this.updateConnectionStatus )
		}

		window.removeEventListener( 'online', this.updateOnLineStatus )
		window.removeEventListener( 'offline', this.updateOnLineStatus )
	}

	updateConnectionStatus = () => {
		if ( ! navigator.onLine ) {
			return
		}

		const { dispatch } = this.props

		dispatch( setConnectionStatus( {
			effectiveType: navigator.connection.effectiveType,
			downlink: navigator.connection.downlink,
			rtt: navigator.connection.rtt
		} ) )
	}

	updateOnLineStatus = () => {
		const { dispatch } = this.props

		dispatch( setOnLineStatus( navigator.onLine ) )
	}

	render() {
		const { location, match } = this.props

		return (
			<Switch>
				{/* Home */}
				<Route path={ match.path } exact render={ props => (
					<SiteLayout type="home" { ...props }>
						<HomeLayout type="home" { ...props } />
					</SiteLayout>
				)} />

				{/* News - Single */}
				<Route path={ `${match.path}article/:slug` } exact render={ props => (
					<SiteLayout type="post" { ...props }>
						<MainLayout type="post" { ...props }>
							<Page type="post" { ...props } />
						</MainLayout>
					</SiteLayout>
				)} />

				{/* News Category */}
				<Route path={ `${match.path}category/:slug` } exact render={ props => (
					<SiteLayout type="category" { ...props }>
						<CategoryLayout type="category" { ...props }>
							<Page type="category" { ...props } />
						</CategoryLayout>
					</SiteLayout>
				)} />

				<Route path={ `${match.path}category/:slug/:archivePageNumber` } exact render={ props => (
					<SiteLayout type="category" { ...props }>
						<CategoryLayout type="category" { ...props }>
							<Page type="category" { ...props } />
						</CategoryLayout>
					</SiteLayout>
				)} />

				{/* Pages and Archives */}
				<Route path={ `${match.path}:slug` } exact render={ props => (
					<SiteLayout type="page" { ...props }>
						<MainLayout type="page" { ...props }>
							<Page type="page" { ...props } />
						</MainLayout>
					</SiteLayout>
				)} />

				<Route path={ `${match.path}:parent/:slug` } exact render={ props => (
					<SiteLayout type="page" { ...props }>
						<MainLayout type="page" { ...props }>
							<Page type="page" { ...props } />
						</MainLayout>
					</SiteLayout>
				)} />

				<Route path={ `${match.path}:slug/:archivePageNumber` } exact render={ props => (
					<SiteLayout type="page" { ...props }>
						<MainLayout type="page" { ...props }>
							<Page type="page" { ...props } />
						</MainLayout>
					</SiteLayout>
				)} />

				{/* Fallback */}
				<Route path={ match.path } render={ props => (
					<SiteLayout type="page" { ...props }>
						<MainLayout type="page" { ...props }>
							<Page type="page" fallback={ true } { ...props } />
						</MainLayout>
					</SiteLayout>
				)} />
			</Switch>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( SiteContainer )
